<template>
  <div class="network-container" :class="{ 'controller-network-container': isController }">
    <el-container class="screen-container main-view">
      <el-header style="position: sticky; top: 0; z-index: 99" v-if="!isController" id="header">
        <div class="flex-layout header-layout">
          <div class="header-icon center trans" :style="{ width: isCollapse ? '45px' : '230px' }">
            <img
              id="netgear_logo"
              src="/static/images/header/logo.png"
              class="trans"
              style="width: 138px"
              v-if="!isCollapse"
            />
          </div>
          <div class="header-toolbar flex-item flex-layout" style="align-items: center">
            <div class="flex-item left">
              <i
                id="menu_collapse"
                :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
                class="f24"
                style="padding-left: 20px; cursor: pointer"
                @click="collapseHandler(!isCollapse)"
              ></i>
            </div>
            <div class="flex-item right">
              <span class="btn-item mr10 pointer">
                Dark Theme
                <el-switch
                  id="user_theme"
                  v-model="userTheme"
                  active-value="dark-theme"
                  inactive-value="light-theme"
                ></el-switch>
              </span>
              <span id="save_handler" class="btn-item mr10 pointer" @click="saveHandler">
                <i class="el-icon-setting"></i>
                {{ $t('maintenance.card4.save') }}
              </span>
              <span id="reboot_menu" class="btn-item pointer" @click="visible = true">
                <i class="el-icon-refresh-left"></i>
                {{ $t('overview.card.reboot') }}
              </span>
              <el-dropdown size="mini" class="toolbar-item" @command="commandQuestionHandler" id="question_help_drpdwn">
                <template #default>
                  <span id="menu_default" class="el-dropdown-link" style="padding-top: 7px">
                    {{ $t('global.question.default')
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                </template>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item id="menu_community" command="community" class="f16">{{
                        $t('global.question.community')
                      }}</el-dropdown-item>
                    <el-dropdown-item id="menu_support" command="support">{{
                        $t('global.question.support')
                      }}</el-dropdown-item>
                    <el-dropdown-item id="menu_register" command="register">{{
                        $t('global.question.register')
                      }}</el-dropdown-item>
                    <el-dropdown-item
                      id="menu_oldui"
                      command="old_ui"
                      v-if="productName !== 'M4500'"
                      :disabled="disableMainUI"
                    >
                      {{ $t('global.question.old_ui') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>

              <el-dropdown size="small" class="toolbar-item" @command="commandHandler" id="user_drpdwn">
                <template #default>
                  <span class="el-dropdown-link">
                    <el-avatar
                      id="user_icon"
                      :icon="UserFilled"
                      size="small"
                      style="vertical-align: middle"
                    ></el-avatar>
                    <span>
                      <span class="username ellipsis">{{ username }}</span>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                  </span>
                </template>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item id="menu_logout" command="logout">{{
                        $t('global.logout.name')
                      }}</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside
          class="left trans"
          id="naviagtion_links"
          :style="{ width: isCollapse ? (isController ? '85px' : '65px') : '250px' }"
          :class="{
            'controller-box': isController,
            'collapse-aside-box': isController && isCollapse,
          }"
        >
          <el-button
            id="back_handler"
            class="back-btn"
            type="text"
            @click.stop="backHandler"
            v-if="isController && !isCollapse"
          >
            <i class="el-icon-arrow-left arrow-icon"></i>
            <span>{{ controller.title }}</span>
          </el-button>

          <el-menu
            id="side_menu"
            class="el-menu-vertical-demo"
            background-color="#fff"
            text-color="#000"
            active-text-color="#409EFF"
            :unique-opened="true"
            :collapse="isCollapse"
            :collapse-transition="false"
            :default-active="getActive"
            style="height: 100%; border-right: none"
          >
            <template v-for="(item, index) in queryMenu" :key="item.title">
              <!-- Group with children -->
              <el-sub-menu v-if="item.children.length > 0" :index="`${index}`">
                <template #title>
                  <i v-if="item.logo" class="icon f24" :class="item.logo" />
                  <label v-else class="menu-img trans"></label>
                  <span v-if="!isCollapse" class="el-submenu-title">{{ item.title }}</span>
                </template>

                <el-menu-item
                  v-for="child in item.children"
                  :key="child.url"
                  :index="child.url"
                  :id="((child.title).replace(/ /g, '_')).toLowerCase()"
                  @click="menuHandler(child.url, child.open)"
                  @dblclick.prevent="reload"
                >
                  {{ child.title }}
                </el-menu-item>
              </el-sub-menu>

              <!-- Single item without children -->
              <el-menu-item
                v-else
                :id="item.title"
                :index="item.url"
                :key="item.url"
                :title="item.title"
                @click="menuHandler(item.url, item.open)"
                @dblclick.prevent="reload"
              >
                <i class="icon" :class="item.logo"></i>
                <span v-if="!isCollapse">{{ item.title }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </el-aside>

        <el-container style="overflow: hidden">
          <div class="collapse-box" v-if="isController">
            <el-button
              id="closeicon_menu"
              type="text"
              class="status-wrapper"
              :icon="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"
              @click.stop="collapseHandler(!isCollapse)"
            ></el-button>
          </div>
          <el-main style="padding: 20px 0 20px 20px">
            <div class="main-container left">
              <router-view v-slot="{ Component }">
                <transition name="slide-fade" mode="out-in">
                  <component :is="Component" v-if="isRouterAlive" :key="routerKey"/>
                </transition>
              </router-view>
            </div>
          </el-main>
          <el-footer class="main-footer right" height="37px" v-if="!isController"
          >© 1996 - 2025 NETGEAR®</el-footer
          >
        </el-container>
      </el-container>
    </el-container>
    <el-backtop></el-backtop>
    <reboot-confirm-dialog v-model:visible="visible" @sure="commandSend"></reboot-confirm-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance, nextTick, watch, onUnmounted } from 'vue'
import {
  useDeviceStore,
  useNetworksStore,
  useAuthStore,
  useMainStore,
  userThemeStore
} from '@/stores'
import rebootConfirmDialog from './configure/overview/reboot-confirm-dialog'
import { useRoute, useRouter } from 'vue-router'
import { useIndex } from '../js/indexMinxin'
import mitt from 'mitt'
import { UserFilled } from '@element-plus/icons-vue'
import { useWebSocketStore } from '@/stores/websocket'
import { ElMessageBox } from 'element-plus'
import { formatHostForUrl } from '@/js/util'
const { userTheme } = userThemeStore()
const wsStore = useWebSocketStore()
const route = useRoute()
const router = useRouter()
const emitter = mitt()
const deviceStore = useDeviceStore()
const networksStore = useNetworksStore()
const mainStore = useMainStore()
const authStore = useAuthStore()

const instance = getCurrentInstance()
const $api = instance?.appContext.config.globalProperties.$api
const $sakura = instance?.appContext.config.globalProperties.$sakura

const { initEmit, initLoopHandler, oldHandler } = useIndex()

// Reactive state variables
const isCollapse = ref(false)
const isRouterAlive = ref(true)
const routerKey = ref(0);
const visible = ref(false)
const timer = ref(null)
const isController = ref(false)
const controller = ref({
  title: '',
  origin: '',
})
const username = ref(sessionStorage.getItem('username'))
//const userTheme = ref(localStorage.getItem('user-theme') || 'light-theme');

// Menu structure
const menu = ref([
  {
    title: 'Configure',
    logo: 'el-icon-setting',
    children: [
      { title: 'Overview', url: '/configure/overview' },
      { title: 'Network Profiles', url: '/configure/virtualNetworks' },
      { title: 'Link Aggregation', url: '/configure/linkAggregation' },
      { title: 'Multicast', url: '/configure/multicast' },
      { title: 'Neighbor', url: '/configure/neighbor' },
      { title: 'Power Over Ethernet', url: '/configure/powerOverEthernet' },
      { title: 'Port Configuration', url: '/configure/portConfiguration' },
      { title: 'Security', url: '/configure/security' },
      { title: 'Maintenance', url: '/configure/maintenance' },
      { title: 'Licenses', url: '/configure/licenses' },
    ],
  },
  {
    title: 'Diagnostics',
    logo: '',
    children: [
      { title: 'Logs', url: '/diagnostics/logs' },
      { title: 'Port Statistics', url: '/diagnostics/portStatistics' },
      { title: 'Troubleshoot', url: '/diagnostics/accessTools' },
      { title: 'Cable Test', url: '/diagnostics/cableTest' },
      { title: 'Port Mirroring', url: '/diagnostics/portMirroring' },
      {
        title: 'Terminal',
        url: `//${formatHostForUrl(location.hostname)}:${location.protocol === 'http:' ? '8081' : '4444'}`,
        open: true,
      },
      { title: 'Support Diagnostic', url: '/diagnostics/supportDiagnostics' },
    ],
  },
])

// Computed properties
// const getActive = computed(() => '/configure/overview');
const getActive = computed(() => route.path)
const isSupportPoE = computed(() => deviceStore.deviceInfo?.poe)

const baseInfo = computed(() => {
  const details = deviceStore.deviceInfo?.details || []
  return details.find((item) => item.unit === mainStore.unit) || {}
})

const isSupportLicense = computed(() => false)

const isSupportTerminal = computed(() => {
  const model = baseInfo.value.model || ''
  return !model.toUpperCase().includes('M4300')
})

const showCableTest = computed(() => {
  const model = baseInfo.value.model || ''
  return !['M4250-16XF', 'M4350-24F4V'].includes(model.toUpperCase())
})

const queryMenu = computed(() => {
  let filteredMenu = JSON.parse(JSON.stringify(menu.value))
  if (!isSupportPoE.value) {
    filteredMenu[0].children = filteredMenu[0].children.filter(
      (item) => item.url !== '/configure/powerOverEthernet',
    )
  }
  if (!isSupportLicense.value) {
    filteredMenu[0].children = filteredMenu[0].children.filter(
      (item) => item.url !== '/configure/licenses',
    )
  }
  if (!isSupportTerminal.value) {
    filteredMenu[1].children = filteredMenu[1].children.filter((item) => !item.open)
  } else {
    if (productName === 'M4500') {
      filteredMenu = updateUrl(filteredMenu)
    } else {
      filteredMenu = updateUrl(filteredMenu, true)
    }
  }
  if (!showCableTest.value || productName.value === 'M4500') {
    filteredMenu[1].children = filteredMenu[1].children.filter(
      (item) => item.url !== '/diagnostics/cableTest',
    )
  }
  return filteredMenu
})

const productName = computed(() => {
  const model = baseInfo.value.model || ''
  return model.split('-')[0]
})

const disableMainUI = computed(() => {
  const ipHttpConfigJSON = sessionStorage.getItem('ipHttpConfig')
  if(ipHttpConfigJSON){
    const ipHttpConfig = JSON.parse(ipHttpConfigJSON)
    const { http, https } = ipHttpConfig
    return !http.mode && !https.mode
  }
  return true
})

const updateUrl = (menu, reboot) => {
  menu[1].children = menu[1].children.map((item) => {
    if (item.open) {
      item.url = item.url.replace(reboot ? '9081' : '8081', reboot ? '8081' : '9081')
    }
    return item
  })
  return menu
}

const backHandler = () => {
  const parentOrigin = document.referrer ? new URL(document.referrer).origin : controller.origin
  parent.postMessage({ type: 'back' }, parentOrigin)
}

const collapseHandler = (value) => {
  isCollapse.value = value
}

const menuHandler = (path, open) => {
  if (open) {
    window.open(path)
  } else if (path) {
    router.push({ path })
  }
}

const commandHandler = (command) => {
  if (command === 'logout') logoutHandler()
}

const commandQuestionHandler = (command) => {
  const urls = {
    community: 'https://community.netgear.com/t5/English/ct-p/English',
    support: 'https://www.netgear.com/support/',
    register: 'https://www.netgear.com/mynetgear/',
  }

  if (command === 'old_ui') {
    oldHandler()
  } else {
    window.open(urls[command])
  }
}

const logoutHandler = () => {
  authStore.logout()
  sessionStorage.removeItem('token')
  router.push('/login') // or use useRouter().push('/login')
  setTimeout(() => location.reload(), 100) // optional full reload
}

const resizeHandler = (event) => {
  collapseHandler(event.target.innerWidth < 1366)
}

const reload = () => {
  isRouterAlive.value = false;
  if(mainStore.unit){
    nextTick(() => {
      isRouterAlive.value = true
      routerKey.value += 1;
    });
    return;
  }
  authStore
    .queryStacking({ loading: true })
    .then(() => {
      nextTick(() => {
        isRouterAlive.value = true
        routerKey.value += 1;
      })
    })
    .catch(() => {
      nextTick(() => {
        isRouterAlive.value = true
        routerKey.value += 1;
      })
    })
}

const commandSend = (type, save) => {
  deviceStore
    .rebootOrShutdownDevice({ power: { type, save } })
    .then((json) => {
      $sakura.sakuraMessage(json.resp.respCode)
      backHandler()
    })
    .catch((err) => {
      if(err.code === 'ECONNABORTED'){
        wsStore.disconnectWebSocket();
        wsStore.stopIdleTracking();
        ElMessageBox.alert($sakura.locale.global.logout.message, $sakura.locale.global.logout.title, {
          type: 'warning',
          showClose: false, callback: action => {
            router.push({ path: '/login' })
          },
        })
      }
    })
}

const saveHandler = () => {
  $api.firmware
    .saveConfiguration({
      switchConfig: { save: true },
    })
    .then((json) => {
      $sakura.sakuraMessage(json.resp.respCode)
    })
    .catch((e) => {
      console.log(e)
    })
}

const initPortList = async() => {
  // if (timer.value) clearTimeout(timer.value)

  if (!networksStore.portList || networksStore.portList.length === 0) {
    await networksStore.queryPortList({ portid: 'all' });
    // .then((json) => {
    //   if (json.resp.respCode !== 0) {
    //     timer.value = setTimeout(initPortList, 3000)
    //   }
    // })
    // .catch((e) => {
    //   timer.value = setTimeout(initPortList, 3000)
    // })
  }
}

const initInfo = (unit) => {
  const details = deviceStore?.deviceInfo?.details || []
  return details.find((item) => item.unit === unit) || {}
}

const isLicense = computed(() => {
  return baseInfo.value.model?.toUpperCase().indexOf('M4300') < 0
})

const initNetWorkRender = () => {
  const one = authStore.unitList.find((item) => item.management)
  if (one) {
    mainStore.setUnit(one.unit)
    mainStore.setUnitModel(one.model)
  }
}

// const toggleTheme = () => {
//   localStorage.setItem("user-theme", userTheme.value);
//   document.documentElement.className = userTheme.value;
// };

const handleWebSocket = () => {
  if (!wsStore.isConnected && !wsStore.socket && !wsStore.logoutTriggered) {
    wsStore.connectWebSocket();
  }
}

// ✅ Watch for route changes and handle WebSocket
watch(() => route.path, handleWebSocket)

watch(() => authStore.unitList, initNetWorkRender, { deep: true, immediate: true })

const queryC = computed(() => route.query)

onMounted(async () => {
  const queryC = ref({})
  if (Object.keys(route.query).length) {
    sessionStorage.setItem('queryC', JSON.stringify(route.query))
    queryC.value = route.query
  } else if (sessionStorage.getItem('queryC')) {
    queryC.value = JSON.parse(sessionStorage.getItem('queryC'))
  }

  if (queryC.value?.token) {
    sessionStorage.setItem("token", queryC.value.token)
  }
  if (queryC.value?.theme) {
    userTheme.value = queryC.value?.theme
  }
  isController.value = !!queryC.value?.serial
  controller.value = { 
      title: queryC.value?.title || '', 
      origin: queryC.value?.origin || '' 
  }

  window.isController = isController.value
  window.origin = queryC.value.origin
  handleWebSocket()

  window.addEventListener('resize', resizeHandler)

  if (!deviceStore.deviceInfo || Object.keys(deviceStore.deviceInfo).length === 0) {
    await deviceStore.queryDeviceInfo()
  }
  setTimeout(() => {
    document.title = baseInfo.value?.model
  }, 500)

  if (!deviceStore.deviceTime || Object.keys(deviceStore.deviceTime).length === 0) {
    await deviceStore.queryDeviceTime({})
  }

  if(!mainStore.unit){
    await authStore.queryStacking({ loading: true })
  }

  initEmit()
  initLoopHandler()
  initPortList()
})

onUnmounted(() => {
  // wsStore.disconnectWebSocket();
})
</script>

<style lang="scss">
// @use "@/css/base.scss";
@use '@/css/base.scss' as *;

.network-container {
  height: 100%;

  .main-view {
    height: 100%;
    position: relative;

    .el-header {
      background-color: #fff;
      border-bottom: 1px solid #e6e6e6;
    }

    .header-layout {
      height: inherit;
      align-items: center;

      .header-icon {
        width: 240px;
        height: inherit;
        line-height: 60px;
        border-right: 1px solid #e6e6e6;
      }

      .header-toolbar {
        .toolbar-item {
          margin: 0 6px;
        }
      }
    }

    .el-aside {
      background-color: #fff;
      border-right: 1px solid #e6e6e6;
      padding-top: 40px;
      position: relative;

      .icon {
        margin-right: 5px;
      }

      .el-sub-menu__title:hover {
        .menu-img {
          color: #fff !important;
        }
      }

      .el-sub-menu__title:hover,
      .el-sub-menu__title:focus,
      .el-sub-menu.is-active .el-sub-menu__title {
        background-color: $color-primary !important;
        color: #fff !important;

        i {
          color: #fff !important;
        }
      }

      .is-active,
      el-menu-item:hover,
      el-menu-item:focus {
        color: $color-primary !important;
        background-color: #fff !important;
      }

      .menu-img {
        width: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: middle;
        background-image: url('/static/images/common/diagnostics.png');
      }

      .is-active .menu-img,
      .el-sub-menu__title:hover .menu-img,
      .el-sub-menu__title:focus .menu-img {
        background-image: url('/static/images/common/diagnostics-active.png') !important;
      }

      .is-active .menu-img,
      .el-submenu__title:hover .menu-img,
      .el-submenu__title:focus .menu-img {
        background-image: url('/static/images/common/diagnostics-active.png');
      }
    }

    .collapse-box {
      position: absolute;
      z-index: 10;
      top: 50%;

      .status-wrapper {
        color: #fff;
        border-radius: 0.8px;
        background-color: #2f8bff;
      }
    }

    .controller-box {
      padding-top: 50px;

      .back-btn {
        position: absolute;
        top: 0;
        left: 32px;
        height: 50px;
      }

      .arrow-icon {
        font-size: 24px;
        display: inline-block;
        vertical-align: middle;
      }

      .el-submenu__title {
        padding-left: 32px !important;
      }

      .el-menu-item {
        padding-left: 60px !important;
      }
    }

    .collapse-aside-box {
      .el-menu--collapse {
        width: 84px;
      }
    }
  }

  .main-footer {
    padding: 10px 0;
    color: rgba(80, 75, 81, 0.5);
    border-top: 1px solid $border-color;
  }

  .btn-item {
    color: #606266;
  }

  .username {
    display: inline-block;
    vertical-align: middle;
    max-width: 120px;
  }
}

.controller-network-container {
  .page-network-container {
    .net-work-face {
      .slot-work-face {
        width: 100% !important;

        .all-slot {
          width: 16.66666%;
        }
      }
    }
  }
}
</style>
